import { Grid, Typography } from "@material-ui/core"
import React, { memo } from "react"
import * as practiceSelectors from "app/redux/practice/practice.selectors"
import { useDispatch, useSelector } from "react-redux"
import Button from "components/Button"
import Translation from "components/Translation"
import { putPracticeFeatures } from "app/redux/practice/practice.actions"
import { useAccessRoles } from "app/components/AccessRoles"
import { Roles } from "app/models/user"
import { CheckBoxGroup } from "components/CheckBoxGroup"
import Form from "app/components/Form"
import { ISupportSettingsFeaturesData } from "./types"
import { useGetDefaultSelectedFeatures, useGetSelectedFeaturesOptions } from "./hooks"
import { mapFormValuesToPayload } from "./utils"

function SupportSettingsFeatureSwitch(): JSX.Element {
  const dispatch = useDispatch()
  const practice = useSelector(practiceSelectors.getPractice)
  const { isAllowed } = useAccessRoles([Roles.Devops])

  const options = useGetSelectedFeaturesOptions()
  const defaultSelectedFeatures = useGetDefaultSelectedFeatures()
  const defaultValues = {
    features: defaultSelectedFeatures,
  }

  const handleSubmit = ({ features }: ISupportSettingsFeaturesData) => {
    dispatch(putPracticeFeatures(mapFormValuesToPayload(features)))
  }

  return (
    <Form cySelector="supportSettingsForm" onSubmit={handleSubmit} defaultValues={defaultValues}>
      <Typography component="h3" variant="h3" gutterBottom={true}>
        <Translation label="feature.switch" />
      </Typography>
      <Grid container={true} justifyContent="space-between" alignItems="flex-end">
        <Grid item={true}>
          <CheckBoxGroup disabled={!isAllowed} options={options} name="features" />
        </Grid>
        <Grid item={true}>
          <Button type="submit" disabled={!practice || !isAllowed} color="secondary" variant="contained">
            <Translation label="support.featureswitch.button.submit" />
          </Button>
        </Grid>
      </Grid>
    </Form>
  )
}

export default memo(SupportSettingsFeatureSwitch)
